export default function orderHasPayments(order) {
  return order.payments && order.payments.length > 0
}
